import React from 'react';
import '../../styles/home.css';

const FAQ_ITEMS: Array<{ q: string; a: string }> = [
  {
    q: 'Como o Stela Guia calcula meu mapa?',
    a: 'Com astronomia de verdade: efemérides calculam Sol, Lua e Ascendente a partir da sua data, hora e local de nascimento — o mesmo motor que os astrólogos usam, e não um texto genérico de jornal.',
  },
  {
    q: 'O que é de graça e o que é pago?',
    a: 'A prévia do mapa, o horóscopo personalizado, biorritmo e ciclo lunar são gratuitos. O mapa completo, as conversas ilimitadas com a Stela e as leituras avançadas usam créditos — nos pacotes de R$ 29 a R$ 99.',
  },
  {
    q: 'O que a Stela é (e o que não é)?',
    a: 'A Stela é uma sensitiva astróloga digital que conhece o SEU mapa e lembra das suas conversas. Ela orienta e ajuda a pensar decisões — não substitui um profissional de saúde ou aconselhamento médico.',
  },
  {
    q: 'Meus dados de nascimento ficam seguros?',
    a: 'Sim: ficam na sua conta, servem só para personalizar suas leituras, e você pode excluir a conta (e os dados) a qualquer momento nas configurações.',
  },
  {
    q: 'A conversa com a Stela lembra de mim?',
    a: 'Sim. A Stela guarda um resumo do que vocês já conversaram — na próxima sessão ela retoma de onde você parou, como uma sensitiva que te conhece de verdade.',
  },
  {
    q: 'Como recebo promoções e avisos?',
    a: 'Só se você quiser: por e-mail ou WhatsApp (ou os dois) — você escolhe na lista de promoções, canal por canal, e pode silenciar quando quiser.',
  },
];

export const StelaFaq: React.FC = () => {
  return (
    <section id="faq" className="faq">
      <h2 className="display" style={{ textAlign: 'center' }}>Dúvidas frequentes</h2>
      <div className="faq-list">
        {FAQ_ITEMS.map((item) => (
          <details key={item.q}>
            <summary>{item.q}</summary>
            <div className="a">{item.a}</div>
          </details>
        ))}
      </div>
    </section>
  );
};